import { Checkbox, FormControlLabel } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";

export default function SettlementExportSectionsList({
  onToggle,
  options,
  selectedSections,
}) {
  return (
    <div className="flex flex-col gap-2">
      {options.map((option) => (
        <FormControlLabel
          key={option.key}
          control={
            <Checkbox
              checked={Boolean(selectedSections[option.key])}
              disabled={option.disabled}
              onChange={() => onToggle(option.key)}
              sx={{
                color: HNSColors.primary[500],
                "&.Mui-checked": { color: HNSColors.primary[500] },
              }}
            />
          }
          label={option.label}
        />
      ))}
    </div>
  );
}
